import {
  GET_BANK_DEPOSITS_ACCOUNTS_REQUEST,
  GET_BANK_DEPOSITS_ACCOUNTS_SUCCESS,
  GET_BANK_DEPOSITS_ACCOUNTS_FAILURE,
  GET_BANK_DEPOSIT_FEES_REQUEST,
  GET_BANK_DEPOSIT_FEES_SUCCESS,
  GET_BANK_DEPOSIT_FEES_FAILURE,
  GET_BANK_DEPOSIT_FEE_DETAILS_REQUEST,
  GET_BANK_DEPOSIT_FEE_DETAILS_SUCCESS,
  GET_BANK_DEPOSIT_FEE_DETAILS_FAILURE,
  CLEAR_BANK_DEPOSIT_FEE_DETAILS
} from 'Store/constants';

const initialState = {
  bankAccounts: {
    data: [],
    isLoading: false,
    error: null
  },
  bankDepositFees: {
    data: [],
    isLoading: false,
    error: null
  },
  bankDepositFeeDetails: {
    data: null,
    isLoading: false,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BANK_DEPOSITS_ACCOUNTS_REQUEST:
      return {
        ...state,
        bankAccounts: {
          ...state.bankAccounts,
          isLoading: true,
          error: null
        }
      };

    case GET_BANK_DEPOSITS_ACCOUNTS_SUCCESS:
      return {
        ...state,
        bankAccounts: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_BANK_DEPOSITS_ACCOUNTS_FAILURE:
      return {
        ...state,
        bankAccounts: {
          ...state.bankAccounts,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_BANK_DEPOSIT_FEES_REQUEST:
      return {
        ...state,
        bankDepositFees: {
          ...state.bankDepositFees,
          isLoading: true,
          error: null
        }
      };

    case GET_BANK_DEPOSIT_FEES_SUCCESS:
      return {
        ...state,
        bankDepositFees: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_BANK_DEPOSIT_FEES_FAILURE:
      return {
        ...state,
        bankDepositFees: {
          ...state.bankDepositFees,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_BANK_DEPOSIT_FEE_DETAILS_REQUEST:
      return {
        ...state,
        bankDepositFeeDetails: {
          ...state.bankDepositFeeDetails,
          isLoading: true,
          error: null
        }
      };

    case GET_BANK_DEPOSIT_FEE_DETAILS_SUCCESS:
      return {
        ...state,
        bankDepositFeeDetails: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_BANK_DEPOSIT_FEE_DETAILS_FAILURE:
      return {
        ...state,
        bankDepositFeeDetails: {
          ...state.bankDepositFeeDetails,
          isLoading: false,
          error: action.payload
        }
      };

    case CLEAR_BANK_DEPOSIT_FEE_DETAILS:
      return {
        ...state,
        bankDepositFeeDetails: {
          data: null,
          isLoading: false,
          error: null
        }
      };

    default:
      return state;
  }
};
